import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthRoutingModule } from './auth-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material/material.module';
import { GlobalModule } from 'src/app/global/global.module';
import { NgxIntlTelInputModule} from 'ngx-intl-tel-input';
import { SharedModule } from 'src/app/shared/shared.module';
import { allComponents } from './all.exports';

@NgModule({
  declarations: [
    ...allComponents
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    GlobalModule,
    NgxIntlTelInputModule,
    SharedModule
  ]
})
export class AuthModule { }
